<template>
    <GmapMap :options="options"
            ref="mapRef"
            :center="center"
            @zoom_changed="zoom = $event"
            :zoom="zoom"
            map-type-id="roadmap"
            style="width: 100%; height: 720px"
            @click="infoWinOpen=false">
        <GmapInfoWindow :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
        </GmapInfoWindow>
        <GmapMarker :key="m.id + m.index"
                    v-for="(m, index) in markers"
                    :position="m.position"
                    :icon="m.icon"
					:zIndex="m.zIndex"
					:label="m.label"
                    :clickable="true"
                    @click="toggleInfoWindow(m,index)"
                    :draggable="false" />
    </GmapMap>
</template>

<script>
	import { gmapApi } from 'vue2-google-maps';
	import { mapState } from 'vuex';

	export default {
		data: function () {
			return {
				center: { lat: 10.0, lng: 10.0 },
				googleMap: null,
				zoom: 10,
				defaultIcon: { url: '/content/images/custom/map-marker.svg' },
                selectedIcon: { url: '/content/images/custom/map-marker-selected.svg' },
				options: {
					zoomControl: true,
					mapTypeControl: false,
					scaleControl: false,
					streetViewControl: false,
					rotateControl: false,
					fullscreenControl: false,
					disableDefaultUi: false
				},
				infoWindowPos: null,
				infoWinOpen: false,
				currentMidx: null,
				infoOptions: {
					content: '',
					//optional: offset infowindow so it visually sits nicely on top of our marker
					pixelOffset: {
						width: 0,
						height: -25
					}
				},
				markers: []
			}
		},
		computed: {
			...mapState({
				currentPage: state => state.listing.currentPage,
                selectedAgent: state => state.listing.selectedAgent,
				listing: state => state.listing.listing,
			}),
			pagedItems() {
				return this.listing.slice((this.currentPage * 10) - 10, (this.currentPage * 10));
			},
		},
		watch: {
			pagedItems: {
				handler: function (newProp, oldProp) {
					this.setMarkers(newProp);
				},
				deep: true,
				immediate: true
			},
            selectedAgent: {
                handler: function (newProp, oldProp) {
					// why are we reseting markers on agent card select
                    //this.setMarkers(this.pagedItems);
					this.makeAgentMarkersActive();
                },
                deep: true,
                immediate: true
            },
		},
		mounted: function () {
			this.$refs.mapRef.$mapPromise.then(() => {
				if (window.google !== undefined && window.google.maps !== undefined) {
					this.defaultIcon = {
						url: '/content/images/custom/map-marker.svg',
						size: new google.maps.Size(40, 40),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(20, 20),
						scaledSize: new google.maps.Size(40, 40),
						labelOrigin: {x: 20, y: 19},
					};

                    this.selectedIcon = {
                        url: '/content/images/custom/map-marker-selected.svg',
                        size: new google.maps.Size(40, 40),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(20, 20),
                        scaledSize: new google.maps.Size(40, 40),
                        labelOrigin: { x: 20, y: 19 },
                    };
				}

				this.setMarkers(this.pagedItems);
			});
		},
		methods: {
			toggleInfoWindow: function (marker, idx) {
				this.infoWindowPos = marker.position;
				this.infoOptions.content = marker.infoText;

				//check if its the same marker that was selected if yes toggle
				if (this.currentMidx == idx) {
					this.infoWinOpen = !this.infoWinOpen;
				}
				//if different marker set infowindow to open and reset current marker index
				else {
					this.infoWinOpen = true;
					this.currentMidx = idx;

				}
			},
			setMarkers(listing) {
				// we use marker count to let us know how many markers there are on the map and when the bound has been extended to each of these markers
				let markerCount = 0;
				this.markers = [];
				if (window.google !== undefined && window.google.maps !== undefined && this.$refs.mapRef !== undefined) {
					let b = new window.google.maps.LatLngBounds();
					let geocoder = new window.google.maps.Geocoder();

					const labels = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
					let labelIndex = 0;

					if (listing.length >= 1) {
						listing.forEach((agent) => {
							// assign a value at the end of IDs to avoid duplicate entries vue error.
							let agentIdCount = 0;

							if (agent.Offices.length >= 1) {
								agent.Offices.forEach((item) => {
									// set markerLabel
									let markerLabel = labels[labelIndex++ % labels.length];

									// Use temp address to get lat/lng when it is not provided
									// Some of the lat/lng from the FB data is not correct
									// we need to use address because of that
									let tempFullAddress = `${item.Address1} ${item.CityState} ${item.Zipcode}`;

									let text = '';

									if (agent.Url !== null) {
										text = `<a href="${agent.Url}"><h4><b>${agent.Name}</b></h4></a>
											    <p class='infobox-summary'>${item.Address1}<br/>`;
									} else {
                                        text = `<h4 class='title-no-link'><b>${agent.Name}</b></h4>
										        <p class='infobox-summary'>${item.Address1}<br/>`;
									}

									if (item.Address2) text += `${item.Address2}<br/>`;
									markerCount++;

									if ((item.Latitude !== null && item.Longitude !== null) && (item.Latitude !== 0 && item.Longitude !== 0)) {
										text += `${item.City}, ${item.State} ${item.Zipcode}</p>
												<a class="view-link" target="_blank" jstcache="6" href='https://maps.google.com/?q=${item.Latitude},${item.Longitude}'><span>Get Directions</span></a>
												<a href="tel:${item.Phone}">${item.Phone}</a>`;

										let marker = {
											position: {
												lat: item.Latitude,
												lng: item.Longitude
											},
											id: `${agent.Email}-${agentIdCount++}`,
											index: labelIndex,
											setMap: this.$refs.mapRef,
											title: agent.Name,
											label: {
												text: markerLabel,
												color: '#FFFFFF',
												fontSize: '16px',
												fontWeight: 'bold'
											},
											infoText: text,
											email: agent.Email
										}

										if (this.selectedAgent === agent.Email) {
											marker.zIndex = 99;
											marker.icon = this.selectedIcon;
										} else {
											marker.zIndex = labelIndex;
											marker.icon = this.defaultIcon;
										}

										// marker obj is complete, we can now add to the markers obj collection.
										// this marker gets added synchronously.
										this.markers.push(marker);

										if (listing.length > 1 || agent.Offices.length > 1) {
											b.extend({
												lat: item.Latitude,
												lng: item.Longitude
											});
										} else if (this.markers.length === 1) {
											b.extend({
												lat: item.Latitude,
												lng: item.Longitude
											});

											this.center = { lat: item.Latitude, lng: item.Longitude };
										}
									} else {
										geocoder.geocode({'address': tempFullAddress}, (results, status) => {
											if (status == 'OK') {
												let location = results[0].geometry.location;
												let latitude = location.lat();
												let longitude = location.lng();

												text += `${item.City}, ${item.State} ${item.Zipcode}</p>
														<a class="view-link" target="_blank" jstcache="6" href='https://maps.google.com/?q=${latitude},${longitude}'><span>Get Directions</span></a>
														<a href="tel:${item.Phone}">${item.Phone}</a>`;

												let marker = {
													position: {
														lat: latitude,
														lng: longitude
													},
													id: `${agent.Email}-${agentIdCount++}`,
													index: labelIndex,
													setMap: this.$refs.mapRef,
													title: agent.Name,
													label: {
														text: markerLabel,
														color: '#FFFFFF',
														fontSize: '16px',
														fontWeight: 'bold'
													},
													infoText: text,
													email: agent.Email
												}

												if (this.selectedAgent === agent.Email) {
													marker.zIndex = 99;
													marker.icon = this.selectedIcon;
												} else {
													marker.zIndex = labelIndex;
													marker.icon = this.defaultIcon;
												}

												// marker obj is complete, we can now add to the markers obj collection.
												// this marker gets added asynchronously.
												this.markers.push(marker);

												if (listing.length > 1 || agent.Offices.length > 1) {
													b.extend({
														lat: latitude,
														lng: longitude
													});
												} else if (this.markers.length === 1) {
													b.extend({
														lat: latitude,
														lng: longitude
													});

													this.center = { lat: latitude, lng: longitude };
												}

												// We only hit this condition if an agent's office did not have either a Lat or Lng value.
												// We hit this when the last GeoCoder async call gets executed and main forEach loop has finished.
												// If this gets hit we won't meet the condition for "fitBounds()" call outside the forEach loop.
												if((markerCount === this.markers.length) && (this.markers.length >= 1)) {
													this.$refs.mapRef.fitBounds(b);
													if (this.markers.length === 1) {
														setTimeout(() => this.zoom = 10, 500);
													}
												}
											}
											// If it goes over the query limit this/these office markers won't get added,
											// but at least we don't throw off the calculation.
											// else if (status == window.google.maps.GeocoderStatus.OVER_QUERY_LIMIT) {}
										})
									}
								});
							}
						});

						// We hit this condition if all agent offices had both Lat&Lng values.
						// We can also hit this when/if the last GeoCoder async call gets executed before the main forEach loop finishes.
						if((markerCount === this.markers.length) && (this.markers.length >= 1)) {
							this.$refs.mapRef.fitBounds(b);
							if (this.markers.length === 1) {
								setTimeout(() => this.zoom = 10, 500);
							}
						}
					}
					else {
						b.extend({
							lat: 41.909541,
							lng: -124.175651
						});

						b.extend({
							lat: 44.835672,
							lng: -67.072421
						});

						this.$refs.mapRef.fitBounds(b);
					}
				}
			},
			makeAgentMarkersActive() {
				if (window.google !== undefined && window.google.maps !== undefined && this.$refs.mapRef !== undefined) {
					let b = new window.google.maps.LatLngBounds();
					let updateMap = false;

					this.markers.forEach((marker) => {
						if (this.selectedAgent === marker.email) {
							marker.zIndex = 99;
							marker.icon = this.selectedIcon;

							var point = new window.google.maps.LatLng(
								parseFloat(marker.position.lat),
								parseFloat(marker.position.lng)
							);
							// add each marker's location to the bounds
							b.extend(point);
							updateMap = true;
						}
						else {
							marker.zIndex = marker.index;
							marker.icon = this.defaultIcon;
						}
					});

					if (updateMap) {
						this.$refs.mapRef.panTo(b.getCenter());
					}
				}
			}
        },
    }
</script>